// REQUIRED
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";
import "vuetify/dist/vuetify.min.css";

// PLUGINS
import "./plugin/vuescrollto";
import VueClipboard from "vue-clipboard2";

// LAST IMPORT
import "babel-polyfill";

// SETTINGS
Vue.use(VueClipboard);
Vue.use(Vuetify, {
  theme: {
    primary: colors.indigo.darken4,
    secondary: colors.indigo.lighten4,
    accent: colors.indigo.base
  }
});

VueClipboard.config.autoSetContainer = true;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js